import { styled } from 'styled-components'
import { motion } from 'framer-motion'
import { COLORS } from 'consts/colors'
import CloseSvg from 'assets/svgr-icons/Close.svg'
import { POPUP_Z_INDEX } from 'consts/zIndex'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const PopupContainer = styled(motion.div)`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${POPUP_Z_INDEX};
`

export const PopupContent = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  max-height: 90%;
  max-width: 90%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.white};
  padding: 32px;
  border-radius: 15px;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    overflow-y: auto;
    padding: 24px 16px;
  }
`

export const CloseIcon = styled(CloseSvg)<{
  onClick?: () => void
}>`
  position: absolute;
  fill: ${COLORS.secondary};
  top: 8px;
  right: 8px;
  z-index: 1;
  cursor: pointer;
`

export const BackdropOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
  background-color: rgba(0, 0, 0, 0.5);
`
